import React, { useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Card, CardContent } from '@/components/ui/card';
import { Heading, Text } from '@/components/ui/typography';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { cn } from '@/lib/utils';
import { validatePassword } from '@/utils/formValidation';

const ResetPassword = () => {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");

  const handleReset = async (e) => {
    e.preventDefault();
    const passwordError = validatePassword(password);
    if (passwordError) {
      setError(passwordError);
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }
    setError("");
    // API call to /reset-password/:token
    await axios.post(`https://aievaluator.in/api/reset-password/${token}`, { password }, { headers: { "Content-Type": "application/json" } });

    alert("Password has been reset successfully!");
  };

  return (
    <div className="min-h-screen w-full bg-background flex items-center justify-center p-4 relative">
      {/* Logo Section - Top Left */}
      <div className="absolute top-6 left-6 md:top-8 md:left-8 z-10">
        <Link 
          to="/"
          className="transition-opacity hover:opacity-80"
        >
          <img
            src="/Logo.png"
            alt="Logo"
            className="h-8 md:h-10 w-auto object-contain drop-shadow-sm"
          />
        </Link>
      </div>
      
      <div className="flex flex-col md:flex-row gap-8 max-w-4xl w-full items-center">
        <img src="/forgot.jpg" alt="team" className="hidden md:block w-1/2 object-contain" />
        <Card className={cn("w-full md:w-1/2", "bg-white")}>
          <CardContent className="p-8">
            <Heading level="h2" className="text-2xl font-bold mb-2 text-center">RESET PASSWORD</Heading>
            <Text className="text-center text-muted-foreground mb-6">Please kindly set your new password.</Text>
            <form onSubmit={handleReset} className="space-y-4">
              <div>
                <Label htmlFor="password">New Password</Label>
                <Input
                  type="password"
                  id="password"
                  placeholder="New Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="mt-1"
                />
              </div>
              <div>
                <Label htmlFor="confirm">Re-enter Password</Label>
                <Input
                  type="password"
                  id="confirm"
                  placeholder="Re-enter Password"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  required
                  className="mt-1"
                />
              </div>
              {error && <Text className="text-sm text-destructive">{error}</Text>}
              <Button type="submit" className="w-full">
                Reset Password
              </Button>
            </form>
            <Link to="/login_user" className="flex items-center gap-2 mt-4 text-muted-foreground hover:text-foreground">
              <ArrowLeft className="w-4 h-4" />
              Back to Login
            </Link>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ResetPassword;
